import { type Track } from './Video'
import { isIOS } from './isIOS'

// Safari's auto-pick lands 60–220 ms after its player opens; a viewer can't
// reach a pick in its menu this fast.
export const SAFARI_DEFAULT_PICK_WINDOW_MS = 1000

export const isIOSNativeFullscreen = (video: HTMLVideoElement) =>
  isIOS() && video.webkitDisplayingFullscreen === true

export const activeTextTrackIndex = (textTracks: TextTrackList) => {
  let activeIdx = -1
  for (let i = 0; i < textTracks.length; i++) {
    if (textTracks[i].mode !== 'disabled') activeIdx = i
  }
  return activeIdx
}

export const disableTextTracks = (textTracks: TextTrackList) => {
  for (let i = 0; i < textTracks.length; i++) {
    if (textTracks[i].mode !== 'disabled') textTracks[i].mode = 'disabled'
  }
}

const primaryLanguage = (tag: string) => {
  try {
    return new Intl.Locale(tag).language
  } catch {
    return tag
  }
}

// iOS Safari lists the stream's in-band subtitles after our <track>s, tagged
// with 3-letter codes (`eng`, `chi`) and their own labels.
export const toSourceTrackIndex = (
  sourceTracks: readonly Track[],
  textTracks: TextTrackList,
  textTrackIdx: number,
) => {
  if (textTrackIdx < sourceTracks.length) return textTrackIdx

  const { language, label } = textTracks[textTrackIdx]
  const primary = primaryLanguage(language)
  const sameLabel = (i: number) =>
    !!label && sourceTracks[i].label.toLowerCase() === label.toLowerCase()
  const sourceIndices = sourceTracks.map((_, i) => i)
  const sameLanguage = sourceIndices.filter(
    (i) => primaryLanguage(sourceTracks[i].srcLang) === primary,
  )

  const sameLanguageAndLabel = sameLanguage.find(sameLabel)
  const firstSameLanguage = sameLanguage[0]
  const sameLabelOnly = sourceIndices.find(sameLabel)

  return sameLanguageAndLabel ?? firstSameLanguage ?? sameLabelOnly ?? -1
}
